import { render, staticRenderFns } from "./AdditionalClauses.vue?vue&type=template&id=cc9f1ba0"
import script from "./AdditionalClauses.vue?vue&type=script&lang=js"
export * from "./AdditionalClauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports